import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../firebase';
import StateContext from '../../StateContext'
import ConditionalFixtureTemplate from './Templates/ConditionalFixtureTemplate';

function UserFavoritedFixturesAPI({type}) {

    const appState = useContext(StateContext)

    const [fixtures, setFixtures] = useState([]);
    const [show, setShow] = useState(true);

    const today = new Date().getTime()

    function isLive(date) {
        if (fixtures) {

            const fixtureDate = new Date(date)
            const fixtureTimestamp = fixtureDate.getTime()
            const today = new Date().getTime()
            
            const timeDiff = today - fixtureTimestamp

            let live = false

            if (timeDiff > 0 && timeDiff < 7200000) {
                // Show api data or update db data if game is live or has finished, so fixture result shows correctly
                live = true
            } else {
                live = false
            }

            return live

        }
    }


    useEffect(() => {

        if (appState.userId) {
            try {
                const favFixturesRef = firestore.collection("users").doc(appState.userId).collection("favoritedFixturesAPI");
                favFixturesRef.onSnapshot(({docs}) => {
                    const fixtures = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    setFixtures(fixtures);
                })
            } catch (error) {
                
            }
        }

    }, [appState.userId])

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    return (
        <div>
            <div 
            className="card card-header bg-lightgrey" 
            onClick={toggle}
            >
                <small>Favorittkamper<span className="float-right"><i className={`${show ? "fas fa-chevron-down" : "fas fa-chevron-up"}`}></i> </span></small> 
            </div>
            {show && (
                <React.Fragment>
                    {fixtures?.map((fixture, index) => {

                        const dateFixture = new Date(fixture.event_date)
                        const statusFixture = isLive(dateFixture)

                        return <ConditionalFixtureTemplate key={index} fixture={fixture} statusFixture={statusFixture} type={type} />

                    })}
                </React.Fragment>
            )}

        </div>
    )

}
export default UserFavoritedFixturesAPI